import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  FiArrowRight,
  FiZap,
  // FiTruck,
  FiSun,
  FiMapPin,
} from 'react-icons/fi';
import Navbar from '../Navbar';
import Footer from '../Footer';
import useInView from '../home/useInView';
import styles from './QuienesSomos.module.css';

const lineasNegocio = [
  {
    icon: FiZap,
    titulo: 'Biogás y energías limpias',
    texto:
      'Plantas de biogás que generan energía a partir de desechos orgánicos y estiércol, en alianza con empresas de servicios públicos como Triple A en Barranquilla.',
  },
  // {
  //   icon: FiTruck,
  //   titulo: 'Movilidad eléctrica',
  //   texto:
  //     'Infraestructura para la carga y operación de vehículos eléctricos, impulsando la transición hacia el transporte sostenible en la región.',
  // },
  {
    icon: FiSun,
    titulo: 'Energía solar fotovoltaica',
    texto:
      'Proyectos solares que aprovechan el potencial energético de la región para generar electricidad limpia y accesible.',
  },
];

const ciudades = ['Bogotá', 'Barranquilla', 'Córdoba'];

function Reveal({ children, delay = 0, className = '' }) {
  const [ref, inView] = useInView(0.15);
  return (
    <div
      ref={ref}
      className={`${styles.reveal} ${inView ? styles.visible : ''} ${className}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      {children}
    </div>
  );
}

function QuienesSomos() {
  const history = useHistory();

  return (
    <>
      <Navbar />

      <main className={styles.page}>
        {/* Hero */}
        <section className={styles.hero}>
          <div className={styles.heroOverlay} />
          <div className={styles.container}>
            <div className={styles.heroInner}>
              <p className={styles.kicker}>Energía renovable · América Latina</p>
              <h1 className={styles.heroTitle}>
                Desarrollando el futuro energético de la región
              </h1>
              <p className={styles.heroText}>
                BCCY es una empresa de origen chino con fuerte presencia en
                América Latina, especializada en el desarrollo, inversión y
                operación de proyectos de energía renovable y gestión de residuos
                sostenibles.
              </p>
            </div>
          </div>
        </section>

        {/* Qué es BCCY */}
        <section className={styles.section}>
          <div className={styles.container}>
            <Reveal>
              <span className={styles.eyebrow}>¿Qué es BCCY?</span>
              <h2 className={styles.sectionTitle}>
                Energía limpia con visión de largo plazo
              </h2>
              <p className={styles.lead}>
                Combinamos inversión, tecnología y conocimiento del territorio
                para desarrollar soluciones energéticas sostenibles que impulsan
                el desarrollo económico y social de América Latina.
              </p>
            </Reveal>
          </div>
        </section>

        {/* Líneas de negocio */}
        <section className={styles.sectionAlt}>
          <div className={styles.container}>
            <Reveal className={styles.centerHead}>
              <span className={styles.eyebrow}>Líneas de negocio</span>
              <h2 className={styles.sectionTitle}>Lo que hacemos</h2>
            </Reveal>

            <div className={styles.grid3}>
              {lineasNegocio.map(({ icon: Icon, titulo, texto }, i) => (
                <Reveal key={titulo} delay={i * 0.12}>
                  <article className={styles.card}>
                    <div className={styles.cardIcon}>
                      <Icon />
                    </div>
                    <h3 className={styles.cardTitle}>{titulo}</h3>
                    <p className={styles.cardText}>{texto}</p>
                  </article>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        {/* Dónde nos encontramos */}
        <section className={styles.section}>
          <div className={styles.container}>
            <div className={styles.grid2}>
              <Reveal>
                <span className={styles.eyebrow}>¿Dónde nos encontramos?</span>
                <h2 className={styles.sectionTitle}>Presencia en Colombia</h2>
                <p className={styles.text}>
                  Operamos bajo las razones sociales{' '}
                  <strong>BCCY Colombia Holding S.A.S. E.S.P.</strong> y{' '}
                  <strong>BCCY Córdoba S.A.S. E.S.P.</strong>, con sede principal
                  en Bogotá. Somos reconocidos por nuestros desarrollos en el
                  sector eléctrico y nuestro enfoque en sostenibilidad.
                </p>

                <div className={styles.ciudades}>
                  {ciudades.map((ciudad) => (
                    <span key={ciudad} className={styles.ciudadChip}>
                      <FiMapPin />
                      {ciudad}
                    </span>
                  ))}
                </div>
              </Reveal>

              <Reveal delay={0.15}>
                <div className={styles.razonesBox}>
                  <div className={styles.razonItem}>
                    <h4>BCCY Colombia Holding S.A.S. E.S.P.</h4>
                    <p>Brazo corporativo y estrategia del grupo.</p>
                  </div>
                  <div className={styles.razonItem}>
                    <h4>BCCY Córdoba S.A.S. E.S.P.</h4>
                    <p>Desarrollo y operación de proyectos regionales.</p>
                  </div>
                  <div className={styles.razonSede}>
                    <FiMapPin />
                    <span>Sede principal: Bogotá Calle 113#7-21 oficina 918</span>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </section>

        {/* CTA final */}
        <section className={styles.cta}>
          <div className={styles.container}>
            <Reveal className={styles.ctaInner}>
              <h2 className={styles.ctaTitle}>
                Conoce nuestras unidades de negocio
              </h2>
              <div className={styles.ctaButtons}>
                <button
                  type="button"
                  className={styles.btnPrimary}
                  onClick={() => history.push('/cordoba')}
                >
                  BCCY Córdoba <FiArrowRight />
                </button>
                <button
                  type="button"
                  className={styles.btnOutline}
                  onClick={() => history.push('/holding')}
                >
                  BCCY Holding <FiArrowRight />
                </button>
              </div>
            </Reveal>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default QuienesSomos;